import isFinite from 'lodash/isFinite';

function cloneItem(
  item,
  col = null,
  isAvailable = null,
  extras = {},
) {
  return [
    item[0],
    Object.assign(
      { ...item[1] },
      col ? { col: isFinite(col) ? { xs: 24, lg: col } : col } : {},
      isAvailable ? { isAvailable } : {},
      { ...extras },
    ),
  ];
}

export default cloneItem;
